export default __webpack_public_path__ + "static/media/2007.d44f6500.png";